import Axios from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { Axios_Route } from "API/AxiosRouts";
import React, { useEffect, useState, FormEvent } from "react";
import { ValidationErrorMessages } from "utils/Error";
import { notify, ToastType } from "utils/Toast";

interface Props {
  Component: any;
}

const PropertyList: React.FC<Props> = ({ Component }) => {
  const [searchDataGot, setSearchDataGot] = useState<boolean>(false);
  const [searchData, setSearchData] = useState<any>();
  const [priceRange, setPriceRange] = useState<any>([]);
  const [propertySize, setPropertySize] = useState<any>([]);
  const [bedData, setBedData] = useState<any>([]);
  const [bathData, setBathData] = useState<any>([]);
  const [allowToSearch, setallowToSearch] = useState<boolean>(true);
  const [allowToSearchByCode, setallowToSearchByCode] = useState<boolean>(true);
  const [searchQueryAdvisor, setSearchQueryAdvisor] = useState<string>("");
  const [searchQueryStatus, setSearchQueryStatus] = useState<string>("");
  const [searchQueryRegion, setSearchQueryRegion] = useState<string>("");
  const [searchQueryPropertyType, setSearchQueryPropertyType] =
    useState<string>("");
  const [searchQueryPropertySize, setSearchQueryPropertySize] =
    useState<string>("");
  const [searchQueryPriceRange, setSearchQueryPriceRange] =
    useState<string>("");
  const [searchQueryBeds, setSearchQueryBeds] = useState<string>("");
  const [searchQueryBaths, setSearchQueryBaths] = useState<string>("");
  const [searchQueryFurnish, setSearchQueryFurnish] = useState<string>("");
  const [searchQueryDepositeCode, setSearchQueryDepositeCode] =
    useState<string>("");
  const [ownerNameQuery, setOwnerNameQuery] = useState<string>("");
  const [ownerMobileQuery, setOwnerMobileQuery] = useState<string>("");
  const [depositeStatus, setDepositeStatus] = useState<any>();
  const [depositeStatusGot, setDepositeStatusGot] = useState<boolean>(false);
  const [tableContent, setTableContent] = useState<any>();
  const [tableContentGot, setTableContentGot] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [isSreach, setIsSreach] = useState<boolean>(false);

  useEffect(() => {
    setBedData([
      { id: 1, title: "1" },
      { id: 2, title: "2" },
      { id: 3, title: "+3" },
    ]);
    setBathData([
      { id: 1, title: "1" },
      { id: 2, title: "2" },
      { id: 3, title: "+3" },
    ]);

    Axios(AxiosMethodEnum.get, Axios_Route.PROPERTY_LIST_SEARCH_BASE).then(
      ({ response, success }) => {
        if (success) {
          setSearchData(response);
          setSearchDataGot(true);
        }
      }
    );

    Axios(AxiosMethodEnum.get, Axios_Route.DEPOSITE_STATUS).then(
      ({ response, success }) => {
        if (success) {
          setDepositeStatus(response);
          setDepositeStatusGot(true);
        }
      }
    );
  }, []);

  const setSearchQueryAdvisorfunc = (id: string) => {
    setSearchQueryAdvisor(id);
  };
  const setSearchQueryStatusfunc = (id: string) => {
    setSearchQueryStatus(id);
  };
  const setSearchQueryRegionfunc = (id: string) => {
    setSearchQueryRegion(id);
  };

  const setSearchQueryPropertyTypefunc = (id: string) => {
    Axios(
      AxiosMethodEnum.get,
      Axios_Route.PROPERTY_LIST_SEARCH_BASE_PRICE_RANGE + id
    ).then(({ response, success }) => {
      if (success) {
        setPriceRange(response);
      }
    });
    Axios(
      AxiosMethodEnum.get,
      Axios_Route.PROPERTY_LIST_SEARCH_BASE_PROPERTY_SIZE + id
    ).then(({ response, success }) => {
      if (success) {
        setPropertySize(response);
      }
    });
    setSearchQueryPropertyType(id);
  };
  const setSearchQueryPropertySizefunc = (id: string) => {
    setSearchQueryPropertySize(id);
  };
  const setSearchQueryPriceRangefunc = (id: string) => {
    setSearchQueryPriceRange(id);
  };
  const setSearchQueryBedsfunc = (id: string) => {
    setSearchQueryBeds(id);
  };
  const setSearchQueryBathsfunc = (id: string) => {
    setSearchQueryBaths(id);
  };
  const setSearchQueryFurnishfunc = (id: string) => {
    setSearchQueryFurnish(id);
  };
  const handleChangeCodeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQueryDepositeCode(e.target.value);
  };

  useEffect(() => {
    if (isSreach) {
      submitSearchQuery(undefined, pageNumber);
    } else {
      Axios(AxiosMethodEnum.get, Axios_Route.DEPOSITE_LIST_WITH_PAGE, {
        pageNumber: pageNumber,
        pageSize: 30,
      }).then(({ response, success }) => {
        if (success) {
          setTableContent(response);
          setTableContentGot(true);
        }
      });
    }
  }, [pageNumber]);

  const submitSearchQuery = (e?: FormEvent, pageNumber: number = 1) => {
    if (e !== undefined) {
      e.preventDefault();
    }

    if (allowToSearch) {
      setallowToSearch(false);
      const SearchObj = {
        adviserId: searchQueryAdvisor,
        areaRangeId: searchQueryPropertySize,
        bathroomCount: searchQueryBaths,
        bedroomCount: searchQueryBeds,
        decorateId: searchQueryFurnish,
        ownerName:ownerNameQuery,
        ownerMobile:ownerMobileQuery,
        isCount: true,
        isDepositId: false,
        pageNumber: pageNumber,
        priceRangeId: searchQueryPriceRange,
        propertyId: searchQueryPropertyType,
        regionId: searchQueryRegion,
        statusId: searchQueryStatus,
      };
      Axios(AxiosMethodEnum.post, Axios_Route.DEPOSITE_SEARCH, SearchObj).then(
        ({ response, success }) => {
          setallowToSearch(true);
          if (success) {
            setTableContent(response);
          } else if (!success) {
            notify(ValidationErrorMessages.ERRORS.TRY_AGAIN, ToastType.error);
          }
        }
      );
    }
    setIsSreach(true);
  };

  const searchByDepositeCode = (e: FormEvent) => {
    e.preventDefault();
    if (allowToSearchByCode) {
      setallowToSearchByCode(false);
      const SearchObj = {
        depositId: searchQueryDepositeCode,
        isCount: true,
        isDepositId: true,
        pageNumber: 1,
      };
      Axios(AxiosMethodEnum.post, Axios_Route.DEPOSITE_SEARCH, SearchObj).then(
        ({ response, success }) => {
          setallowToSearchByCode(true);
          if (success) {
            setTableContent(response);
          } else if (!success) {
            notify(ValidationErrorMessages.ERRORS.TRY_AGAIN, ToastType.error);
          }
        }
      );
    } else {
      notify(ValidationErrorMessages.ERRORS.FIELD_REQUIRED, ToastType.error);
    }
  };

  return (
    <div>
      <Component
        searchDataGot={searchDataGot}
        searchData={searchData}
        priceRange={priceRange}
        propertySize={propertySize}
        bedData={bedData}
        bathData={bathData}
        setSearchQueryAdvisorfunc={setSearchQueryAdvisorfunc}
        setSearchQueryStatusfunc={setSearchQueryStatusfunc}
        setSearchQueryRegionfunc={setSearchQueryRegionfunc}
        setSearchQueryPropertyTypefunc={setSearchQueryPropertyTypefunc}
        setSearchQueryPropertySizefunc={setSearchQueryPropertySizefunc}
        setSearchQueryPriceRangefunc={setSearchQueryPriceRangefunc}
        setSearchQueryBedsfunc={setSearchQueryBedsfunc}
        setSearchQueryBathsfunc={setSearchQueryBathsfunc}
        setSearchQueryFurnishfunc={setSearchQueryFurnishfunc}
        submitSearchQuery={submitSearchQuery}
        ownerNameQuery={ownerNameQuery}
        setOwnerNameQuery={setOwnerNameQuery}
        ownerMobileQuery={ownerMobileQuery}
        setOwnerMobileQuery={setOwnerMobileQuery}
        depositeStatus={depositeStatus}
        depositeStatusGot={depositeStatusGot}
        tableContent={tableContent}
        tableContentGot={tableContentGot}
        searchQueryDepositeCode={searchQueryDepositeCode}
        handleChangeCodeInput={handleChangeCodeInput}
        searchByDepositeCode={searchByDepositeCode}
        setPageNumber={setPageNumber}
      />
    </div>
  );
};

export default PropertyList;
